var React = require('react');

function SearchIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"clip-path"},React.createElement("rect",{"id":"Rectangle_290","data-name":"Rectangle 290","width":"19","height":"19","fill":"none","strokeWidth":"1"}))),React.createElement("g",{"id":"Icon","clipPath":"url(#clip-path)","key":1},[React.createElement("circle",{"id":"Ellipse_9","data-name":"Ellipse 9","cx":"7","cy":"7","r":"7","transform":"translate(1 1)","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":0}),React.createElement("line",{"id":"Line_2","data-name":"Line 2","x2":"5","y2":"5","transform":"translate(13 13)","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1})])]);
}

SearchIcon.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19"};

module.exports = SearchIcon;

SearchIcon.default = SearchIcon;
